<template>
  <div @keyup.enter.native="handleLogin"
       class="login-container">
    <div class="login-weaper  animated bounceInDown">
      <div class="login-left">
        <img alt=""
             class="img"
             src="/img/youhuaguo.png">
        <p class="title">{{website.infoTitle}}</p>
      </div>
      <div class="login-border">
        <div class="login-main">
          <userLogin v-if="activeName==='user'"></userLogin>
          <!-- <div class="login-menu">
            <a href="http://localhost:8061/swagger-ui.html" target="_blank">swagger api</a>
          </div> -->
        </div>
      </div>
    </div>
    <div class="copyright-wrap">
      Copyright ©2020 meidia.fruitbomb.com.cn All Rights Reserved 北京有花果文化传媒有限公司版权所有 <a class="copywrite-link" target="_blank" href="http://www.beian.miit.gov.cn">京ICP备17055193号-2</a>
    </div>
  </div>
</template>
<script>
  import '@/styles/login.scss'
  import userLogin from "./userlogin";
  import {mapGetters} from "vuex";

  export default {
    name: "login",
    components: {
      userLogin
    },
    data() {
      return {
        activeName: "user"
      };
    },
    watch: {},
    created() {
    },
    mounted() {
    },
    computed: {
      ...mapGetters(["website"])
    },
    props: [],
    methods: {}
  };
</script>

<style lang="scss" scoped>
.copyright-wrap {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 10px;
  text-align: center;
  font-size: 12px;
  .copywrite-link {
    &:link,
    &:hover,
    &:visited,
    &:active {
      text-decoration: none;
      outline: none;
    }
    &:hover {
      color: #00acac;
    }
  }
}
</style>
